import { loadContent } from './loadContent.js';
import { addScrollListeners, handleScroll, scrollToHashElement } from './scrollHandlers.js';
import { addMouseOverListeners } from './mouseHandlers.js';
import { addDataPageAttribute, updatePageNumberAndHistory } from './pageNumberHandlers.js';
import { addLoader, removeLoader } from './loaders.js';
import { addButtonListeners } from './buttonHandlers.js';

class InfiniteScroll {
    constructor(config) {
        const settings = config || {};

        const defaults = {
            container: '#js-infinity-scroll-container',
            paginationPrev: '#js-infinity-scroll-prev',
            paginationNext: '#js-infinity-scroll-next',
            itemCard: '.js-item-card-wrapper',
            offset: 300,
            loadMoreText: 'Load more',
            loadingText: 'Loading...',
            loader: '#js-infinity-scroll-loader',
            scroll: true,
            button: false,
            buttonSelector: '#js-infinity-scroll-button'
        };

        this.settings = Object.assign({}, defaults, settings);

        this.containerElement = document.querySelector(this.settings.container);
        this.containerElements = this.containerElement?.querySelectorAll(this.settings.itemCard)
        this.paginationNextElement = document.querySelector(this.settings.paginationNext);
        this.paginationPrevElement = document.querySelector(this.settings.paginationPrev);
        this.loader = document.querySelector(this.settings.loader);
        this.loaderTextElement = this.loader?.querySelector('#loader-text');
        this.loading = false;

        this.scroll = this.settings.scroll;
        this.button = this.settings.button;
        this.buttonElement = this.button ? document.querySelector(this.settings.buttonSelector) : null;

        this.currentPage = parseInt(this.getCurrentPage(), 10) || 1;
        this.firstLoadedPage = this.currentPage;
        this.lastLoadedPage = this.currentPage;
        this.direction = null;

        this.lastScrollTop = window.scrollY || document.documentElement.scrollTop;
        this.firstItemTopPosition = this.paginationPrevElement?.getBoundingClientRect().top + this.lastScrollTop || 0;
        
        this.addScrollListeners = addScrollListeners.bind(this);
        this.addButtonListeners = addButtonListeners.bind(this);
        this.loadContent = loadContent.bind(this);
        this.addLoader = addLoader.bind(this);
        this.removeLoader = removeLoader.bind(this);
        this.addDataPageAttribute = addDataPageAttribute.bind(this);
        this.handleScroll = handleScroll.bind(this);
        this.addMouseOverListeners = addMouseOverListeners.bind(this);
        this.scrollToHashElement = scrollToHashElement.bind(this);
        this.updatePageNumberAndHistory = updatePageNumberAndHistory.bind(this);
        
         this.initialize();

         //if the device is ios - reload the page when coming back from bfcache
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            if (isIOS) {
                window.addEventListener('pageshow', (event) => {
                    if (event.persisted) {
                        window.location.reload();
                    }
                });
            }
    }

    

    initialize() {
        if (!this.containerElement) {
            return;
        }

        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
        this.scrollToHashElement();

        this.addDataPageAttribute(this.currentPage);
        this.addMouseOverListeners(this.containerElement, this.settings.itemCard);
        
        if (this.scroll === true || this.scroll === 'true') {
            this.addScrollListeners();
        } else if (this.button === true || this.button === 'true') {
            this.addButtonListeners();
        }

        window.addEventListener('beforeunload', (event) => {
            const element = document.activeElement;
            if (element && element.closest(this.settings.itemCard)) {
                const card = element.closest(this.settings.itemCard);
                
                this.updatePageNumberAndHistory(card);
            }
        });
    }

    getCurrentPage() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        return urlParams.get('page') || 1;
    }

    destroy() {
        // Remove event listeners
        if (this.scroll === true || this.scroll === 'true') {
            // Remove scroll listener (it's debounced, so we need to remove all scroll listeners)
            window.removeEventListener('scroll', this.handleScroll);
        } else if (this.button === true || this.button === 'true') {
            if (this.buttonElement) {
                // Remove button click listener
                this.buttonElement.removeEventListener('click', this.buttonClickHandler);
            }
        }
        
        // Clear any existing infinite scroll instance
        if (window.currentInfiniteScroll === this) {
            window.currentInfiniteScroll = null;
        }
    }

    static reinitialize(config) {
        // Find existing infinite scroll instances and destroy them
        if (window.currentInfiniteScroll) {
            // Preserve the original configuration if no config is provided
            const originalConfig = window.currentInfiniteScroll.settings;
            window.currentInfiniteScroll.destroy();
            
            // Use the provided config or fall back to original config
            const newConfig = config || originalConfig;
            const newInstance = new InfiniteScroll(newConfig);
            window.currentInfiniteScroll = newInstance;
            return newInstance;
        }
        
        // If no existing instance, create new one with provided config
        const newInstance = new InfiniteScroll(config);
        window.currentInfiniteScroll = newInstance;
        return newInstance;
    }

    
}


 
window.InfiniteScroll = InfiniteScroll;
